import { render, staticRenderFns } from "./CampaignType.vue?vue&type=template&id=1ebb6e98"
import script from "./CampaignType.vue?vue&type=script&lang=js"
export * from "./CampaignType.vue?vue&type=script&lang=js"
import style0 from "./CampaignType.vue?vue&type=style&index=0&id=1ebb6e98&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports